import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import { Link } from "react-router-dom";

const Tarjeta_Novedades = ({ Novedad, imagen, link }) => {
    const { sCell } = useResponsive();

    return (
        <Link
            to={link}
            style={{
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
            }}
        >
            <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    {/* Imagen */}
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        size={{ xs: 3, sm: 3, md: 3 }}
                    >
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            size={{ xs: 12, sm: 12, md: 12 }}
                            sx={{ mb: 0 }}
                        >
                            <img
                                src={imagen}
                                alt={Novedad}
                                style={{
                                    width: '100%',
                                    borderRadius: '12px',
                                }}
                            />
                        </Grid>
                    </Grid>

                    {/* Texto */}
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="flex-start"
                        size={{ xs: 9, sm: 9, md: 9 }}
                        sx={{ pl: 2 }}
                    >
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="flex-start"
                            size={{ xs: 12, sm: 12, md: 12 }}
                        >
                            <Typography
                                component="h3"
                                sx={(theme) => ({
                                    fontSize: 15,
                                    [theme.breakpoints.down(1300)]: {
                                        fontSize: 15,
                                    },
                                    [theme.breakpoints.down(1200)]: {
                                        fontSize: 12,
                                    },
                                    [theme.breakpoints.down(900)]: {
                                        fontSize: 11,
                                    },
                                    [theme.breakpoints.down(600)]: {
                                        fontSize: 16,
                                    },
                                    [theme.breakpoints.down(400)]: {
                                        fontSize: 16,
                                    },
                                    fontWeight: 500,
                                    color: 'black',
                                })}
                            >
                                {Novedad}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Link>
    );
};

export default Tarjeta_Novedades;